import React, { FC, useState } from "react";
import { UIBrandedFareInfo, UIFlightSegment } from "@flights/types";
import Frame from "components/elements/Frame";
import { CardAncillariesWithIcon } from "@flights/search-ui";
import { useFlightCardLuggageWithCheckmarksController } from "./useFlightCardLuggageWithCheckmarksController";
import { Stack, Text } from "@bookingcom/bui-react";
import { lowerCase, startCase } from "lodash";
import flights_web_flexible_ticket_icon from "utils/experiments/funnel/flights_web_flexible_ticket_icon";

export const FlightCardLuggageWithCheckmarks: FC<{
  segments: UIFlightSegment[];
  showFareName: boolean;
  brandedFareInfo?: UIBrandedFareInfo;
  showFlexIcon?: boolean;
}> = ({ segments, showFareName, brandedFareInfo, showFlexIcon = false }) => {
  const { cabinBagText, personalBagText, checkedBagText, titleText, flexTicketText } =
    useFlightCardLuggageWithCheckmarksController(segments);

  /* start - flights_web_flexible_ticket_icon */
  const [popoverOpened, setPopoverOpened] = useState(false);
  const handlePopoverOpen = () => {
    if (!popoverOpened) {
      flights_web_flexible_ticket_icon.goals.popoverTriggered();
    }
    setPopoverOpened(true);
  };
  /* end - flights_web_flexible_ticket_icon */

  if (!cabinBagText && !personalBagText && !checkedBagText && !showFlexIcon) {
    return null;
  }

  return (
    <Stack gap={0.5}>
      {showFareName && brandedFareInfo && <BrandedFareDescription {...brandedFareInfo} />}
      <CardAncillariesWithIcon
        align="end"
        personalBagText={personalBagText}
        cabinBagText={cabinBagText}
        checkedBagText={checkedBagText}
        /* start - flights_web_flexible_ticket_icon */
        onPopoverOpen={handlePopoverOpen}
        titleText={!flights_web_flexible_ticket_icon.trackWithDefaultStage() ? titleText : undefined}
        flexTicketText={showFlexIcon ? flexTicketText : undefined}
        /* end - flights_web_flexible_ticket_icon */
      />
    </Stack>
  );
};

const BrandedFareDescription = (brandedFareInfo?: UIBrandedFareInfo) => {
  if (!brandedFareInfo) {
    return null;
  }

  return (
    <Frame>
      <Text variant="small_1" align="end" color="neutral">
        {startCase(lowerCase(brandedFareInfo.fareName))}
      </Text>
    </Frame>
  );
};

export default FlightCardLuggageWithCheckmarks;
